import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './bank_agent.css';
import { useNavigate } from 'react-router-dom';

function BankAgent() {
    const [banks, setBanks] = useState([]);
    const [subsidiaryId, setSubsidiaryId] = useState('');
    const [subsidiaryName, setSubsidiaryName] = useState('');
    const [currencyId, setCurrencyId] = useState('');
    const [currencyName, setCurrencyName] = useState('');
    const [bankname, setBank] = useState('');


    const [selectedBank, setSelectedBank] = useState('');
    const [file, setFile] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const navigate = useNavigate();

    // Load banks on mount
    useEffect(() => {
        axios
            .get('/api/netsuite/account')
            .then(res => setBanks(res.data))
            .catch(console.error);
    }, []);

    // When bank changes, fetch its subsidiary & currency
    useEffect(() => {
        if (!selectedBank) {
            setSubsidiaryId('');
            setSubsidiaryName('');
            setCurrencyId('');
            setCurrencyName('');
            setBank('');
            return;
        }
        axios
            .get(`/api/netsuite/account/${selectedBank}`)
            .then(res => {
                const data = res.data;
                // assume data comes back like { subsidiaryId, subsidiaryName, currencyId, currencyName }
                setSubsidiaryId(data[0].subsidiary);
                setSubsidiaryName(data[0].subsidiary);
                setCurrencyId(data[0].currency);
                setCurrencyName(data[0].currencyname);
                setBank(data[0].id)
            })
            .catch(() => {
                setSubsidiaryId('');
                setSubsidiaryName('');
                setCurrencyId('');
                setCurrencyName('');
                setBank('');

            });
    }, [selectedBank]);

    const handleSubmit = async () => {
        if (!selectedBank || !file) {
            alert("Both fields are mandatory.");
            return;
        }
        setIsLoading(true);

        try {
            // Step 1: Get OpenAI Auth Key
            const keyRes = await axios.get('/api/get_key');
            const authKey = keyRes.data;

            console.log('bankname', bankname);

            // Step 2: Send file to OpenAI for JSON
            const formData = new FormData();
            formData.append('file', file);
            formData.append('auth_key', authKey[0].auth_key);
            formData.append('bank', bankname);
            formData.append('subsidiary', subsidiaryId);
            formData.append('currency', currencyId);
            

            await axios.post('/api/clear-session', {}, {
                withCredentials: true
            });
            const response = await axios.post('/api/convert', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                withCredentials: true  // ✅ If you use Flask sessions
            });
            console.log('response Key:', response);
            const { ai_response } = response.data;
            console.log('response.data Key:', response.data);
            const cleaned = response.data;
            const chatresponse = await axios.post('/api/bankagent/chat', {
                messages: 'User provided the bank statement file here:Please map with Netsuite customer and validate\n by calling ****Netsuite_customer tool call ***** And present user details of matched customer' + JSON.stringify(cleaned, null, 2)
            }, {
                withCredentials: true   // ✅ send cookie to maintain session
            });
            console.log("chatresponse.data.message:-----//", chatresponse.data.message);
            const message = chatresponse.data.message;
            var parsedMessage = JSON.parse(message);
            console.log("message:-----//user_message", parsedMessage.user_message);

            // try {
            //     const response = await axios.post('/api/bankagent/chat', {
            //       messages: "go ahead and validate customers"
            //     },{
            //       withCredentials: true   // ✅ send cookie to maintain session
            //   });
          
            //     const assistantMsg = response.data.message;
            //     console.log('assistantMsg:', assistantMsg);
            //     var parsedMessage = JSON.parse(assistantMsg);
            //     navigate('/chat', { state: { messages: [{ role: 'assistant', content: parsedMessage.user_message }] } });

            //   } catch (error) {
            //   }
            // Step 3: Navigate to chat page and pass initial message
            navigate('/chat', { state: { messages: [{ role: 'assistant', content: parsedMessage.user_message }] } });
        } catch (err) {
            console.error("Error:", err);
            alert("Something went wrong");
        }
        setIsLoading(false);

        // const response = await axios.post('/api/process-bank-statement', formData);
        // Redirect to chat view with extracted data
    };

    return (
        <div className="bank-agent-container">
            <h2 className="bank-agent-title">Bank Statement Processing</h2>
            <div className="bank-agent-form">

                {/* Bank selector */}
                <div className="form-group">
                    <label>Select Bank</label>
                    <select
                        value={selectedBank}
                        onChange={e => setSelectedBank(e.target.value)}
                    >
                        <option value="">--Select--</option>
                        {banks.map(b => (
                            <option key={b.id} value={b.id}>
                                {b.name}
                            </option>
                        ))}
                    </select>
                </div>

                {/* Subsidiary (read-only dropdown) */}
                <input
                    type="hidden"
                    name="subsidiaryId"
                    value={subsidiaryId}
                />

                {/* Currency (read-only dropdown) */}
                <div className="form-group">
                    <label>Currency</label>
                    <select value={currencyId} disabled>
                        {currencyId
                            ? <option value={currencyId}>{currencyName}</option>
                            : <option value="">--Select Bank First--</option>
                        }
                    </select>
                </div>


                {/* File upload */}
                <div className="form-group">
                    <label>Upload Bank Statement</label>
                    <input
                        type="file"
                        onChange={e => setFile(e.target.files[0])}
                    />
                </div>

                {/* Submit */}
                <button
                    className="submit-button"
                    onClick={handleSubmit}
                    disabled={isLoading}
                >
                    {isLoading ? 'Processing...' : 'Submit'}
                </button>

                {isLoading && (
                    <div className="loading-wrapper">
                        <div className="loader" />
                        <p>Processing your file, please wait...</p>
                    </div>
                )}
            </div>
        </div>
    );
}

export default BankAgent;